import { createApp } from 'vue';
import App from './../App.vue';
import { AppInsightsPlugin } from 'vue3-application-insights';

export default async ({ store, router }) => {
  const config = store.getters['config/config'];

  createApp(App)
    .use(router)
    .use(AppInsightsPlugin, {
      router: router,
      appInsightsConfig: {
        config: {
          instrumentationKey: config.APPLICATION_INSIGHTS.INSTRUMENTATION_KEY,
          connectionString: config.APPLICATION_INSIGHTS.CONNECTION_STRING,
          disableAjaxTracking: false,
          enableAjaxErrorStatusText: true,
          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
          enableAutoRouteTracking: true, // we are not using vue router
          enableUnhandledPromiseRejectionTracking: true,
          trackInitialPageView: false,
        },
      },
      trackAppErrors: true,
    });
};
